<template lang="pug">
#page_content.intro.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row.justify-content-center: .col-sm-10
			h2.title 2022台灣國際兒童影展－大螢幕搶先看」實體放映活動。
			p.content
				| 開放索票期間：2月10日（四）中午 12 時 至 2月17日（四）中午 12 時。
				br
				| 索票入口：
				a(href='https://www.accupass.com/event/2201060744023855725650', target='_blank') 請點此
				| 或至 Accupass 搜尋「2022台灣國際兒童影展」。
			h3.title 索票須知
			ul
				li 於 Accupass 網路報名，每人限報名一場，並以 1 組雙人套票為限。（舉例：一家四口看影展，需用 2 個身分證字號各自下單 1 組票券，共取得 4 張電影票。）
				li 2月18日（五）下午 18 時以前，將依報名順序寄出「報名成功」通知信，額滿為止。同一身分證字號請勿重複報名超過一場活動，否則將會收到報名失敗通知信。
				li 請家長參考各場次之適合觀賞年齡，選擇合適的場次索票。
			h3.title 入場方式
			ul
				li 現場出示索票時使用之身分證件及 Accupass 電子票券 QRcode。
				li 電影開演前 20 分鐘至 5 分鐘開放入場，開演前 10 分鐘仍未到場者，視同放棄。
				li 電影開演前 5 分鐘將開放現場民眾補位入場，由工作人員帶領進入。
				li 入場後須離開影廳者蓋印章作為辨識。
			p.content －各場次前 100 名入場的觀眾，皆可免費獲得精美小禮品乙份！
			h3.title 注意事項
			ul
				li 為維護觀影品質，敬請準時入場。恕不開放遲到觀眾入場。
				li 非經許可，演出與活動進行時禁止攝影、錄影或錄音。
				li 本活動依實聯制措施指引規範入場，實聯制蒐集之個資將於活動日起算保留 28 日後刪除。
				li 入場時請配合測量體溫與酒精消毒，額溫超過攝氏 37.5 度者將婉拒入場。請全程配戴口罩，禁止飲食，並配合現場防疫指引和措施。
				li 活動將視嚴重特殊傳染性肺炎（COVID-19）疫情變化，遵循中央流行疫情指揮中心規定進行調整， 並同步公告於活動網站及臉書粉絲專頁。
				li 主辦單位保有活動內容異動、索票及入場方式異動之權利，請密切注意活動網站及臉書粉絲專頁最新公告。
			p.content 如有索票相關問題，歡迎私訊臉書粉絲專頁詢問。
			img.big(src='@/assets/images/faq/campaign.png')
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/demo.jpg',
				title: '索票方式',
			},
		};
	},
	components: {
		Banner,
	},
};
</script>
<style lang="stylus">
#page_content.intro
	.article
		img
			display: flex
			&.big
				width: 60%
				margin: 0 auto 30px
			&.small
				width: 25%
				margin: 0 10px 20px 0
			@media screen and (max-width: $screen-sm-max)
				&.big
					width: 100%
				&.small
					width: 100%
		ul
			margin: 1rem 0 2.5rem 0
		.img_group
			display: flex
			justify-content: center
			flex-wrap: wrap
		.note
			color: $color_light
			margin: 20px 0 60px 0
		.content
			text-align: left
			color: #fff
			line-height: 2
			margin-bottom: 30px
		a
			color: $color_yellow
</style>
